type ItemsPagination = {
    currentPage: number;
    maxPages: number;
    sidesNum: number;
    showInitialPage: boolean;
    showFinalPage: boolean;
    isMaxPageNum: boolean;
    maxNumberPagesShow: number;
};
export const itemsPagination = ({
    currentPage,
    maxPages,
    sidesNum,
    showInitialPage,
    showFinalPage,
    isMaxPageNum,
    maxNumberPagesShow,
}: ItemsPagination): number[] => {
    const offsetNumSide = sidesNum >= 3 ? 2 : 0;
    let leftSide = (showInitialPage || showFinalPage) && !isMaxPageNum ? currentPage - offsetNumSide : currentPage - sidesNum;
    let rightSide = sidesNum >= 3 && isMaxPageNum ? currentPage + 2 : currentPage + 1;
    const items = [];
    if (leftSide <= 0) {
        leftSide = 1;
        rightSide = isMaxPageNum ? maxNumberPagesShow : sidesNum + 1;
    }
    if (rightSide > maxPages) {
        leftSide = isMaxPageNum ? 1 : maxPages - 1 - offsetNumSide;
        rightSide = maxPages;
    }
    for (let number = leftSide; number <= rightSide; number++) {
        items.push(number);
    }
    return items;
};
